export const  EmptyStateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="201"
      fill="none"
    >
      <path
        fill="#0038FF"
        d="M189.076 67.322c-4.58-11.162-11.6-21.512-20.619-29.355-10.577-9.2-27.263-16.29-41.371-11.276-14.598 5.189-24.365 17.63-35.192 27.746-3.802 3.552-7.961 6.92-12.894 8.898-22.593 9.057-37.938-3.293-57.972 10.703s-21.74 41.987-8.526 59.687c13.215 17.7 44.758 15.23 68.629 15.23 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.896 51.586-78.813-.921-6.754-2.767-13.57-5.45-20.109z"
      ></path>
      <path
        fill="#fff"
        d="M189.076 67.322c-4.58-11.162-11.6-21.512-20.619-29.355-10.577-9.2-27.263-16.29-41.371-11.276-14.598 5.189-24.365 17.63-35.192 27.746-3.802 3.552-7.961 6.92-12.894 8.898-22.593 9.057-37.938-3.293-57.972 10.703s-21.74 41.987-8.526 59.687c13.215 17.7 44.758 15.23 68.629 15.23 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.896 51.586-78.813-.921-6.754-2.767-13.57-5.45-20.109z"
        opacity="0.7"
      ></path>
      <path
        fill="#0038FF"
        d="M93.987 39.089c-2.764-1.508-4.02-.252-5.025-1.508-1.006-1.256 2.763-4.523-4.774-7.789 0 0-.503-7.035-10.804-7.286-10.301-.251-7.538 7.035-10.301 8.794-2.764 1.759-3.518-1.005-6.281.754-2.764 1.759-1.508 5.276-3.77 5.779-2.26.502-5.276-2.262-8.04-.503-2.763 1.759-2.763 3.266-4.02 3.266-1.256 0-3.768-1.005-5.276 0-1.507 1.005-3.266 2.261-3.266 2.261h63.566s.754-2.261-2.01-3.768z"
      ></path>
      <path
        fill="#fff"
        d="M93.987 39.089c-2.764-1.508-4.02-.252-5.025-1.508-1.006-1.256 2.763-4.523-4.774-7.789 0 0-.503-7.035-10.804-7.286-10.301-.251-7.538 7.035-10.301 8.794-2.764 1.759-3.518-1.005-6.281.754-2.764 1.759-1.508 5.276-3.77 5.779-2.26.502-5.276-2.262-8.04-.503-2.763 1.759-2.763 3.266-4.02 3.266-1.256 0-3.768-1.005-5.276 0-1.507 1.005-3.266 2.261-3.266 2.261h63.566s.754-2.261-2.01-3.768z"
        opacity="0.5"
      ></path>
      <path
        fill="#fff"
        d="M146.164 49.706c-1.776-.969-2.583-.162-3.229-.969-.645-.807 1.776-2.905-3.067-5.003 0 0-.323-4.52-6.941-4.681-6.618-.162-4.842 4.52-6.618 5.65-1.775 1.13-2.26-.646-4.035.484-1.776 1.13-.969 3.39-2.422 3.712-1.452.323-3.389-1.452-5.165-.322-1.775 1.13-1.775 2.098-2.582 2.098-.807 0-2.422-.645-3.39 0-.969.646-2.099 1.453-2.099 1.453h40.838c.001 0 .485-1.454-1.29-2.422z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M163.758 95.94H34.037v40.935h129.721V95.94z"
      ></path>
      <path
        fill="#0038FF"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M99.069 58.592L34.379 95.94h129.379l-64.69-37.348z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M125.18 92.613h-32.1v44.261h32.1v-44.26z"
      ></path>
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M125.18 92.613h-32.1v1.883h32.1v-1.883zm-8.034 44.261h-16.032v-27.667a8.016 8.016 0 0116.032 0v27.667z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M99.078 103.11H24.723v33.765h74.355V103.11z"
      ></path>
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M99.078 103.11H24.723v1.506h74.355v-1.506z"
      ></path>
      <path
        fill="#0038FF"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M90.897 105.895H32.904v30.979h57.993v-30.979zM61.9 78.408l-39.462 22.783h78.923L61.901 78.408z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M101.362 101.191H22.439v1.919h78.923v-1.919z"
      ></path>
      <path
        fill="#0038FF"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M109.13 79.766L88.693 91.564h40.874L109.13 79.766z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M129.566 91.564H88.693v1.895h40.873v-1.895zm-89.853 16.821h-4.697v4.696h4.697v-4.696zm7.045 0H42.06v4.696h4.697v-4.696zm7.044 0h-4.696v4.696h4.696v-4.696zm7.045 0H56.15v4.696h4.697v-4.696zm7.044 0h-4.696v4.696h4.696v-4.696zm7.045 0H70.24v4.696h4.696v-4.696zm7.045 0h-4.697v4.696h4.697v-4.696zm7.045 0h-4.697v4.696h4.697v-4.696zm-49.313 6.91h-4.697v4.697h4.697v-4.697zm7.045 0H42.06v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H56.15v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H70.24v4.697h4.696v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697zm-49.313 6.912h-4.697v4.697h4.697v-4.697zm7.045 0H42.06v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H56.15v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H70.24v4.697h4.696v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697zm-49.313 6.91h-4.697v4.697h4.697v-4.697zm7.045 0H42.06v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H56.15v4.697h4.697v-4.697zm7.044 0h-4.696v4.697h4.696v-4.697zm7.045 0H70.24v4.697h4.696v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697zm7.045 0h-4.697v4.697h4.697v-4.697z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M104.351 131.96v4.915"
      ></path>
      <path fill="#222" d="M112.98 136.875v-26.142h-8.629v19.062"></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M112.98 136.875v-26.142h-8.629v19.062"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M167.436 136.874h-47.428V92.613l23.714-12.847 23.714 12.847v44.261z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M171.06 94.496l-27.338-14.812-27.339 14.812-.85-1.57 28.189-15.273 28.19 15.273-.852 1.57z"
      ></path>
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M120.008 92.613v1.076l23.714-12.847 23.714 12.847v-1.076l-23.714-12.847-23.714 12.847z"
      ></path>
      <path fill="#fff" d="M133.345 103.361v-4.666h20.463v23.26"></path>
      <path
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M133.345 103.361v-4.666h20.463v23.26"
      ></path>
      <path fill="#fff" d="M153.808 124.358v4.578h-20.463v-23.798"></path>
      <path
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M153.808 124.358v4.578h-20.463v-23.798"
      ></path>
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M152.445 107.785h-7.958v5.531h7.958v-5.531zm0 7.349h-7.958v5.531h7.958v-5.531zm0-15.073h-7.958v5.905h7.958v-5.905zm-9.777 0h-7.958v5.905h7.958v-5.905zm0 15.073h-7.958v5.531h7.958v-5.531zm0-7.349h-7.958v5.531h7.958v-5.531zm9.777 14.699h-7.958v5.089h7.958v-5.089zm-9.777 0h-7.958v5.089h7.958v-5.089z"
      ></path>
      <path
        stroke="#222"
        strokeDasharray="0.95 1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M134.054 155.13h9.879M37.731 47.281h-1.235a7.41 7.41 0 00-7.41 7.41v93.029a7.41 7.41 0 007.41 7.409h89.736m34.99-100.438a7.41 7.41 0 00-7.41-7.41H44.317"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M161.028 58.253c-16.861.095-30.453 13.841-30.359 30.703.095 16.861 13.841 30.453 30.703 30.358 16.861-.095 30.453-13.841 30.358-30.702-.095-16.861-13.841-30.453-30.702-30.359zm.31 55.033c-13.532.076-24.564-10.832-24.64-24.364-.076-13.532 10.832-24.564 24.364-24.64 13.531-.076 24.563 10.832 24.64 24.364.076 13.532-10.832 24.563-24.364 24.64z"
      ></path>
      <path
        fill="#fff"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M161.018 56.503c-16.861.096-30.453 13.841-30.358 30.703.095 16.861 13.841 30.453 30.702 30.358 16.861-.095 30.453-13.841 30.358-30.702-.095-16.861-13.841-30.453-30.702-30.359zm.309 55.033c-13.531.076-24.563-10.832-24.64-24.364-.076-13.532 10.832-24.564 24.364-24.64 13.532-.076 24.564 10.832 24.64 24.364.077 13.532-10.831 24.563-24.364 24.64z"
      ></path>
      <path
        fill="#0038FF"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M164.039 145.455l-4.642.026a1.373 1.373 0 01-1.381-1.366l-.138-24.477a1.373 1.373 0 011.365-1.381l4.643-.027a1.373 1.373 0 011.381 1.366l.138 24.478a1.374 1.374 0 01-1.366 1.381z"
      ></path>
      <path
        fill="#222"
        stroke="#222"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="0.476"
        d="M164.673 178.467l-6.242.033a3.479 3.479 0 01-3.498-3.46l-.019-36.537a2.72 2.72 0 012.704-2.736l7.761-.043a2.719 2.719 0 012.735 2.704l.02 36.54a3.48 3.48 0 01-3.461 3.499z"
      ></path>
    </svg>
  );
}

export default EmptyStateIcon;
